// Faixa "Desfazer" embaixo da tela (0.67, texto 05 C1/C2). Fica 5 segundos.
import { Pressable, Text, View } from 'react-native';
import { fechar, usarDesfazer } from '../lib/desfazer';
import { C, useCores } from './theme';
import { t } from '../lib/i18n';

export function FaixaDesfazer() {
  const a = usarDesfazer();
  const { accent } = useCores();
  if (!a) return null;
  const texto = a.tipo === 'excluir'
    ? (a.n > 1 ? '🗑️ ' + t('{n} itens excluídos', { n: a.n }) : '🗑️ ' + t('Item excluído'))
    : (a.n > 1 ? '📦 ' + t('{n} itens arquivados', { n: a.n }) : '📦 ' + t('Item arquivado'));
  return (
    <View pointerEvents="box-none" style={{ position: 'absolute', left: 16, right: 16, bottom: 96, alignItems: 'center' }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 12, backgroundColor: C.card2, borderRadius: 14, paddingVertical: 12, paddingHorizontal: 14,
        borderWidth: 1, borderColor: C.line, maxWidth: 520, width: '100%', shadowColor: '#000', shadowOpacity: 0.2, shadowRadius: 8, elevation: 6 }}>
        <Text style={{ color: C.text, flex: 1 }} numberOfLines={1}>{texto}</Text>
        <Pressable hitSlop={10} onPress={() => { a.desfazer(); fechar(); }}><Text style={{ color: accent, fontWeight: '800' }}>{t('Desfazer')}</Text></Pressable>
      </View>
    </View>
  );
}
